import filter from 'lodash/fp/filter';
import reduce from 'lodash/fp/reduce';

export const filterByMultipleConditions = (conditions) => (items) => filter((item) =>
    reduce((result, condition) => result || condition(item), false)(conditions)
  )(items);

